import React from 'react';
import { FontAwesomeConfigurations } from '../../../utils/Configuration/FontAwesomeConfiguration';
import { NotificationModuleProps } from '../../modules/NotificationModule';
import JUNONotificationDisplay from '../JUNONotificationDisplay';
import './style.scss';

interface JUNOActionMenuHeader {
  order: number;
  text: string;
}
export interface JUNOActionMenuItem {
  icon?: string;
  header: number;
  onclick: Function;
  id: number;
  order: number;
  text: string;
  isCheckbox?: boolean;
  isChecked?: boolean;
  disabled?: boolean;
}
export interface JUNOActionMenuProps {
  items: JUNOActionMenuItem[];
  headers: JUNOActionMenuHeader[];
  mobile_props?: NotificationModuleProps;
  help_text?: string;
}

const JUNOActionMenu: React.FC<JUNOActionMenuProps> = ({ ...props }) => {
  const isMobile = App.INSTANCE.isPhone();
  props.items?.sort((a, b) => {
    if (a.header < b.header) {
      return -1;
    }
    if (a.header == b.header) {
      return 0;
    }
    if (a.header > b.header) {
      return 1;
    }
  });
  props.headers?.sort((a, b) => {
    if (a.order < b.order) {
      return -1;
    }
    if (a.order == b.order) {
      return 0;
    }
    if (a.order > b.order) {
      return 1;
    }
  });
  return (
    <>
      <div className="action_menu_drop_container">
        {props.headers?.map((header, i) => {
          return (
            <div key={`header_${header.order}`}>
              {isMobile && props.mobile_props ? (
                <div className="notification_display_container">
                  <JUNONotificationDisplay {...props.mobile_props} />
                </div>
              ) : (
                <div className={`action_menu_dropdown_header`}>
                  {isMobile && props.help_text ? (
                    <div className="action_menu_dropdown_sub_header">
                      <p className="h3">Notification Preferences</p>
                      <p className="help_text_header">{header.text}</p>
                      <p className="help_text">{props.help_text}</p>
                    </div>
                  ) : (
                    <>{header.text}</>
                  )}
                </div>
              )}
              {props.items
                ?.filter(item => item.header == header.order)
                ?.map((item, index) => {
                  if (item.isCheckbox) {
                    return (
                      <div className="action_menu_dropdown_item" key={`item_${index}`}>
                        <div className={`icon`}>
                          <div className="checkbox_container">
                            <label>
                              <input
                                id={`am_checkbox_${index}`}
                                type="checkbox"
                                name={item.text}
                                value={item.text}
                                checked={item.isChecked}
                                onChange={() => {
                                  item.onclick(!item.isChecked);
                                }}
                              />
                              <span className="checkmark_span"></span>
                            </label>
                          </div>
                        </div>
                        {item.text}
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className={`action_menu_dropdown_item ${!item.disabled ? 'hover' : ''}`}
                        key={`item_${index}`}
                        onClick={() => {
                          item.onclick(item.id);
                        }}
                      >
                        <div className={`icon`}>
                          <i className={`${item.icon} fa-fw`} />
                        </div>
                        {item.text}
                      </div>
                    );
                  }
                })}

              {props.help_text && !isMobile && (
                <div className="action_menu_dropdown_footer margin_top">
                  <i className={FontAwesomeConfigurations.ICON_CIRCLE_INFO}></i>
                  <div>
                    <span className="help_text_header">Notification Details</span>
                    <span className="help_text">{props.help_text}</span>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default JUNOActionMenu;
